import { Container } from "@wisr/react-ui";
import React from "react";

import facebook from "../../../../assets/images/footer/Facebook.svg";
import instagram from "../../../../assets/images/footer/Instagram.svg";
import linkedin from "../../../../assets/images/footer/Linkedin.svg";
import twitter from "../../../../assets/images/footer/Twitter.svg";
import wisrFooter from "../../../../assets/images/footer/wisr-footer.svg";
import style from "./loan-offer-footer.scss";
import { BRAND_WEBSITE } from "../../../../shared/url.consts";

export const LoanOfferFooter = () => {
  const links = [
    {
      label: "Privacy and Credit Reporting Policy",
      url: `${BRAND_WEBSITE}/privacy-policy`,
    },
    {
      label: "Terms of Use",
      url: `${BRAND_WEBSITE}/terms-of-use`,
    },
    {
      label: "Credit Guide",
      url: `${BRAND_WEBSITE}/credit-guide`,
    },
    {
      label: "Target Market Determination",
      url: `${BRAND_WEBSITE}/target-market-determination`,
    },
  ];

  const socials = [
    {
      name: "facebook",
      icon: facebook,
      url: "https://www.facebook.com/wisraustralia",
    },
    {
      name: "instagram",
      icon: instagram,
      url: "https://www.instagram.com/wisraustralia/",
    },
    {
      name: "linkedin",
      icon: linkedin,
      url: "https://www.linkedin.com/company/wisr-australia",
    },
    {
      name: "twitter",
      icon: twitter,
      url: "https://twitter.com/wisraustralia",
    },
  ];
  return (
    <>
      <style jsx>{style}</style>

      <footer>
        <div className="bg-navy">
          <Container>
            <div className="row">
              <div className="column copyright-column">
                <span className="copyright">&#169; Wisr 2025</span>
              </div>
              <div className="column">
                <div className="sub-row">
                  <div className="sub-column link-list-column">
                    <ul className="links-list">
                      {links.map((link, i) => (
                        <li key={i}>
                          <a href={link.url} target="_blank" rel="noreferrer">
                            {link.label}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="sub-column socials-column">
                    <ul>
                      {socials.map((social, i) => (
                        <li key={i}>
                          <a href={social.url} target="_blank" rel="noreferrer">
                            <img
                              src={social.icon}
                              alt={`${social.name}-icon`}
                            />
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </div>

        <div className="bg-teal">
          <Container>
            <div className="row">
              <div className="column logo-column">
                <img src={wisrFooter} alt="wisr-logo" />
              </div>
              <div className="column">
                <p>
                  Wisr Finance Pty Ltd ACN 119 503 221 holds an Australian
                  Credit Licence No. 458572 and an Australian Financial Service
                  Licence No. 458572 and is a 100% owned subsidiary of Wisr
                  Limited (ASX: WZR). Wisr Services Pty Ltd ACN 616 806 949
                  provides rate estimates and other services as an agent for
                  Wisr Finance Pty Ltd. Personal loans funded by Wisr are issued
                  by Wisr Finance Pty Ltd. All credit activities are subject to
                  Wisr&apos;s standard terms, conditions and policies.
                </p>
              </div>
            </div>
          </Container>
        </div>
      </footer>
    </>
  );
};
